<template>
    <v-container class="justify-center">
        <v-row class="justify-center">
            <v-col cols="12" sm="12" md="6" lg="4" v-for="(item,index) in leagues.races" :key="index">
                <v-hover v-slot:default="{ hover }">
                    <v-card
                        class="mx-auto"
                        :class="{cardBlurGreen: item.availableSlots, cardBlurRed:!item.availableSlots}"
                        max-width="400"
                    >
                        <v-expand-transition>
                            <div
                                v-if="hover && item.availableSlots"
                                style="background-color: rgba(118,235,108,0.4);"
                                class="cardHover cardBlurGreen d-flex transition-fast-in-fast-out v-card--reveal display-2 white--text"
                            >
                                <v-btn 
                                class="ma-auto white--text"
                                color="#76EB6C"
                                link
                                large
                                @click="go( leagueId, item.raceId )"
                                >
                                    Sprawdź
                                <v-icon right>touch_app</v-icon>
                                </v-btn>
                            </div>
                            <div
                                v-if="hover && !item.availableSlots"
                                style="background-color: rgba(255,87,82,0.4);"
                                class="cardHover cardBlurRed d-flex transition-fast-in-fast-out v-card--reveal display-2 white--text"
                            >
                                <v-btn 
                                class="ma-auto white--text" 
                                color="#FF5752"
                                link
                                large
                                @click="go( leagueId, item.raceId )"
                                >
                                    Brak miejsc
                                <v-icon right>block</v-icon>
                                </v-btn>
                            </div>
                        </v-expand-transition>
                        <v-img :src="leagues.leagueBanner"
                            height="100"
                        ></v-img>
                        <v-list-item>
                            <v-list-item-content class="text-center ma-2">
                                <v-list-item-title class="headline">{{ item.raceName }}</v-list-item-title>
                                <v-list-item-subtitle>{{ leagueName }} league</v-list-item-subtitle>
                                <v-list-item-subtitle>Date: {{ item.raceDate }}</v-list-item-subtitle>
                                <v-list-item-subtitle>Localization: {{ item.raceLocalization }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12">
                                    <div class="text-center" height="100"> 
                                        <l-map
                                        :zoom="zoom"
                                        :center="item.location"
                                        style="height: 100px; width: 100%"
                                        >
                                        <l-tile-layer :url="url" :attribution="attribution"/>
                                        <l-marker :lat-lng="item.location" v-if="item.location">
                                        </l-marker>
                                        </l-map>
                                    </div>
                            </v-col>
                        </v-row>

                        <v-card-text class="mb-0 pb-0">
                            <v-row v-if="item.beforeRaceDate">
                                <v-col cols="12" class="align-center pb-1 d-flex flex-column justify-center">
                                    <div class="ma-1">Miejsca <v-icon>supervisor_account</v-icon>: {{ item.amountOfSlots }}</div>
                                    <div class="ma-1">Wolne miejsca <v-icon>group_add</v-icon>: {{ item.availableDriverSlots }}</div>
                                    <div class="ma-1">Długość trasy <v-icon>fa-road</v-icon>: {{ item.loopLenght }} km</div>
                                    <div class="ma-1">Czas podejsćia <v-icon>alarm</v-icon>: {{ item.timePerStage }} min</div>
                                    <div class="headline ma-2">Cena biletu <v-icon>fa-money-bill-wave</v-icon>: {{ item.lowerPrice ? item.tickerPrice : item.preTicketPrice}} pln</div>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12 d-flex flex-column justify-center align-center">
                                    <div class="ma-1">Wyścig już się odbył.</div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
    .cardHover{
        position:absolute; 
        height: 100%;
        width:100%; 
        z-index:999;
    }
    .cardBlurGreen{
        box-shadow: inset 0 0 0.3em 0.005em gold, 0 0 0.3em 0.005em #76EB6C;
    }
    .cardBlurRed{
        box-shadow: inset 0 0 0.3em 0.005em gold, 0 0 0.3em 0.005em #FF5752;
    }
</style>
<script>
import { LMap, LTileLayer, LMarker} from 'vue2-leaflet';
export default {
    name:'LeagueOverView',
    components: {
        LMap,
        LTileLayer,
        LMarker
    },
    data(){
        return{
        zoom:12,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        leagueName:'Time-Attack',
        }
    },
    // beforeCreate:{
    //     checkData(){
    //         for(i=0;i< ;i++){
    //             if(this.$route.params.league_id == this.$store.state.league[i].leagueId)
    //         }
    //     }
    // },
    computed:{
        leagueId(){ 
            return parseInt(this.$route.params.league_id)
        },
        leagues(){
            return this.$store.getters.getLeague(this.leagueId);
        }
    },
    methods:{
        go(leagueId,raceId){
            this.$router.push({ name:'racePage', params:{league_id: leagueId, race_id: raceId}});
        }
    },
    mounted(){
        if(this.$store.state.leagues.length==0){
            this.$store.dispatch('fetchLeagueData')
        }
    }
}
</script>